var GPay_TransactionState = /* @__PURE__ */ ((GPay_TransactionState2) => {
  GPay_TransactionState2["SUCCESS"] = "SUCCESS";
  GPay_TransactionState2["ERROR"] = "ERROR";
  return GPay_TransactionState2;
})(GPay_TransactionState || {});
const allowedCardNetworks = [
  "AMEX",
  "DISCOVER",
  "INTERAC",
  "JCB",
  "MASTERCARD",
  "MAESTRO",
  "VISA"
];
export {
  GPay_TransactionState,
  allowedCardNetworks
};
//# sourceMappingURL=types.js.map
